export const ContentTypes = {
  Excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  OctetStream: 'application/octet-stream',
  Pdf: 'application/pdf',
};
